import { render, staticRenderFns } from "./previewmaterials.vue?vue&type=template&id=422f1804&scoped=true"
import script from "./previewmaterials.vue?vue&type=script&lang=js"
export * from "./previewmaterials.vue?vue&type=script&lang=js"
import style0 from "./previewmaterials.vue?vue&type=style&index=0&id=422f1804&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422f1804",
  null
  
)

export default component.exports